import { useState } from 'react'
import { useLang } from '../i18n/LangProvider'
import { t, Lang } from './i18n'
import dialogStyles from '../styles/Dialog.module.css'

export function AddJugadorModal({
  onAdd,
  onClose,
  titulo,
  lang: langProp,
}: {
  onAdd: (nombre: string) => Promise<void>
  onClose: () => void
  // Issue #80: el mismo formulario sirve para jugador, entrenador o delegado.
  titulo?: string
  lang?: Lang
}) {
  // 2026-10-23 (club: "hay traducciones que no están bien"): sin idioma, t() caía siempre en
  // euskera aunque la app estuviera en castellano.
  const ctxLang = useLang()
  const lang = langProp ?? ctxLang
  const [nombre, setNombre] = useState('')

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!nombre.trim()) return
    await onAdd(nombre.trim())
  }

  return (
    <dialog open className={dialogStyles.dialog}>
      {titulo && <h3>{titulo}</h3>}
      <form onSubmit={handleSubmit}>
        <label>
          {t('nombre', lang)}
          <input autoFocus value={nombre} onChange={(e) => setNombre(e.target.value)} required />
        </label>
        <div className="modal-actions">
          <button type="submit">{t('anadir', lang)}</button>
          <button type="button" onClick={onClose}>
            {t('cancelar', lang)}
          </button>
        </div>
      </form>
    </dialog>
  )
}
